import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';

import { ButtonsWithOther } from './formFields/ButtonsWithOther';
import { Buttons } from './formFields/Buttons';
import { RadioCard } from './formFields/RadioCard/RadioCard';
import { Checkboxes } from './formFields/Checkboxes';

const useStyles = makeStyles({
  narrow: {
    maxWidth: '70%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

const QuestionnaireFormFieldsBuilder = ({
  options,
  step,
  questionId,
  onSetValue,
  onPushValue,
  onRemoveValue,
  onRemoveValues,
}) => {
  const classes = useStyles();

  switch (step) {
    case 0:
      return <ButtonsWithOther options={options} questionId={questionId} onChange={onSetValue} />;
    case 1:
      return (
        <RadioCard
          options={options}
          questionId={questionId}
          onPush={onPushValue}
          onRemove={onRemoveValues}
        />
      );
    case 2:
      return (
        <div className={classes.narrow}>
          <Buttons
            options={options}
            questionId={questionId}
            onPush={onPushValue}
            onRemove={onRemoveValues}
          />
        </div>
      );
    case 3:
      return (
        <Checkboxes
          options={options}
          questionId={questionId}
          onSet={onPushValue}
          onRemove={onRemoveValue}
        />
      );
    default:
      return null;
  }
};

QuestionnaireFormFieldsBuilder.propTypes = {
  step: PropTypes.number.isRequired,
  onSetValue: PropTypes.func.isRequired,
  onRemoveValue: PropTypes.func.isRequired,
  onRemoveValues: PropTypes.func.isRequired,
  onPushValue: PropTypes.func.isRequired,
  questionId: PropTypes.number.isRequired,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        answerId: PropTypes.number.isRequired,
        answerLabel: PropTypes.string.isRequired,
        type: PropTypes.string,
      }),
    ),
    PropTypes.shape({
      answerId: PropTypes.number.isRequired,
      answerLabel: PropTypes.string.isRequired,
      type: PropTypes.string,
    }),
  ]).isRequired,
};

export default QuestionnaireFormFieldsBuilder;
